import { Divider, Grid, Link, Stack, styled, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";

import fbIcon from "../media/fbicon.png";
import twitterIcon from "../media/twittericon.png";
import linkedinIcon from "../media/linkedinicon.png";
import Iconify from "./Iconify";
import logo from "../media/logo2.png";
import androidBadge from "../media/google-play-badge.png";
import iosBadge from "../media/ios.svg";
import CustomButton from "./CustomButton";

const OrganisateurPart = () => {

  return (
    <>


      <Box sx={{ bgcolor: '#1F1F1F', color: 'white', border:'1px solid #1F1F1F' }}>
        <Container>
          <Stack my={5} spacing={2} alignItems={'center'}>
             <Typography
                        sx={{ fontSize: "35px", fontWeight: "bold" }}
                      >
                        Vous organisez un évènement ?
                      </Typography>
            <Typography>Vendez vos billets à la bonne personne, au bon moment, avec le bon message, au bon prix et via le bon canal.</Typography>
            <CustomButton target="_blank" href="https://organisateurs.choptonticket.com" type={'secondaire'} buttonText={'Publier mon évènement'}/>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default OrganisateurPart;